	export enum PatientStatusEnum {
		Active = 1,
		Inactive = 2,
		Pending = 3,
		Deceased = 4
	}
